import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'

const initialState = {
  countUnread: 0
}

export const notificationSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setCountUnread: (state, action) => {
      state.countUnread = action.payload
    },
    resetNotificationStateAction: () => initialState
  }
})

export const { setCountUnread, resetNotificationStateAction } =
  notificationSlice.actions
export const notificationSelector = (state: RootState) =>
  state.notificationReducer
export default notificationSlice.reducer
